import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import {
  setSortFieldDocumentationGenerales,
  setOrderDocumentationGenerales,
  setCurrentPageDocumentationGenerales,
  setValueDocumentationGenerales,
  setCategorieDocumentationGenerales,
  setTypeDocumentationGenerales,
  setAnneeDocumentationGenerales,
} from "../../store/actions";
import ReactPaginate from "react-paginate";
import { useSelector, useDispatch } from "react-redux";
import {
  Col,
  Row,
  Card,
  CardBody,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import useDebounce from "./useDebounce";
import { useNavigate } from "react-router-dom";
import Config from "config";
import DeleteButton from "components/Common/DeleteButtonList";
import LastModificationAlert from "components/Common/Alert";

function DocumentationGenerales() {
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [docData, setDocData] = useState([]);
  const token = localStorage.getItem("auth_token_" + api);
  const badgeStyle = { fontSize: "100%" };

  const currentPage = useSelector(
    (state) => state.FiltreDocumentationGenerales.currentPage
  );
  const itemsPerPage = 20;

  const value = useSelector(
    (state) => state.FiltreDocumentationGenerales.value
  );
  const categorie = useSelector(
    (state) => state.FiltreDocumentationGenerales.categorie
  );
  const type = useSelector(
    (state) => state.FiltreDocumentationGenerales.type
  );
  const annee = useSelector(
    (state) => state.FiltreDocumentationGenerales.annee
  );
  const debounceSearch = useDebounce(value, 500);

  const sortField = useSelector(
    (state) => state.FiltreDocumentationGenerales.sortField
  );
  const order = useSelector(
    (state) => state.FiltreDocumentationGenerales.order
  );
  const [isSorting, setIsSorting] = useState(false);

  const handleSorting = async (sortFieldVal, sortOrder) => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/documentation_generales?page=1&sort_by=${sortFieldVal}_${sortOrder}&key=${debounceSearch}&categories_document=${categorie}&types_document=${type}&annee=${annee}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const newData = await response.json();
      setDocData(newData);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  const handleSortingChange = (accessor) => {
    dispatch(setCurrentPageDocumentationGenerales(1));
    setIsSorting(true);
    const sortOrder =
      accessor === sortField && order === "asc" ? "desc" : "asc";
    dispatch(setSortFieldDocumentationGenerales(accessor));
    dispatch(setOrderDocumentationGenerales(sortOrder));
    handleSorting(accessor, sortOrder);
    setIsSorting(false);
  };

  document.title = "Documentation générale | DOM COM";

  useEffect(() => {
    if (localStorage.getItem("key") === "true") {
      toast.success("Mise à jour réussie");
      localStorage.setItem("key", "false");
    }
  }, []);

  const fetchPage = async (page) => {
    try {
      const res = await fetch(
        `https://www.fluxod.com/${api}/documentation_generales?page=${page}&sort_by=${sortField}_${order}&key=${debounceSearch}&categories_document=${categorie}&types_document=${type}&annee=${annee}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const data = await res.json();
      return data;
    } catch (error) {
      console.error("Error fetching page: ", error);
    }
  };

  const handlePageChange = async (data) => {
    let page = data.selected + 1;
    const getData = await fetchPage(page);
    dispatch(setCurrentPageDocumentationGenerales(page));
    setDocData(getData);
  };

  const handleFilterChange = (accessor, val) => {
    const updatedFilters = docData.filters.map((filter) => {
      if (filter.accessor === accessor) {
        return { ...filter, value: val };
      }
      return filter;
    });
    setDocData((prevData) => ({ ...prevData, filters: updatedFilters }));
  };

  const handleFiltering = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/documentation_generales?page=${currentPage}&sort_by=${sortField}_${order}&key=${debounceSearch}&categories_document=${categorie}&types_document=${type}&annee=${annee}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) navigate(`${backUrl}/forbidden`);
      if (response.status === 500) navigate(`${backUrl}/error`);
      if (response.status === 203) navigate(`${backUrl}/error404`);
      if (response.status === 401) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser_" + api);
        localStorage.removeItem("sideBar_" + api);
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }
      const newData = await response.json();
      setDocData(newData);
    } catch (error) {
      console.error("Erreur lors de la récupération des données : ", error);
    }
  };

  const renderFilters = () => {
    return (
      <>
        {!loading ? (
          <>
            {docData?.filters?.map((filter, index) => {
              switch (filter.accessor) {
                case "key":
                  return (
                    <Col md={2} className="mb-1" key={index}>
                      <input
                        defaultValue={value}
                        className="form-control mb-3 mb-xxl-0"
                        type="text"
                        placeholder={filter.label}
                        onChange={(e) => {
                          dispatch(setValueDocumentationGenerales(e.target.value));
                          dispatch(setCurrentPageDocumentationGenerales(1));
                          handleFilterChange(filter.accessor, e.target.value);
                        }}
                      />
                    </Col>
                  );
                case "categories_document":
                  return (
                    <Col md={2} className="mb-1" key={index}>
                      <select
                        value={categorie}
                        className="form-control mb-3 mb-xxl-0"
                        onChange={(e) => {
                          dispatch(setCategorieDocumentationGenerales(e.target.value));
                          dispatch(setCurrentPageDocumentationGenerales(1));
                          handleFilterChange(filter.accessor, e.target.value);
                        }}
                      >
                        <option value="">{filter.label}</option>
                        {filter.list.map((item, itemIndex) => (
                          <option key={itemIndex} value={item.id}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </Col>
                  );
                case "types_document":
                  return (
                    <Col md={2} className="mb-1" key={index}>
                      <select
                        value={type}
                        className="form-control mb-3 mb-xxl-0"
                        onChange={(e) => {
                          dispatch(setTypeDocumentationGenerales(e.target.value));
                          dispatch(setCurrentPageDocumentationGenerales(1));
                          handleFilterChange(filter.accessor, e.target.value);
                        }}
                      >
                        <option value="">{filter.label}</option>
                        {filter.list.map((item, itemIndex) => (
                          <option key={itemIndex} value={item.id}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </Col>
                  );
                case "annee":
                  return (
                    <Col md={2} className="mb-1" key={index}>
                      <select
                        value={annee}
                        className="form-control mb-3 mb-xxl-0"
                        onChange={(e) => {
                          dispatch(setAnneeDocumentationGenerales(e.target.value));
                          dispatch(setCurrentPageDocumentationGenerales(1));
                          handleFilterChange(filter.accessor, e.target.value);
                        }}
                      >
                        <option value="">{filter.label}</option>
                        {filter.list.map((item, itemIndex) => (
                          <option key={itemIndex} value={item.id}>
                            {item.label}
                          </option>
                        ))}
                      </select>
                    </Col>
                  );
                default:
                  return null;
              }
            })}
          </>
        ) : (
          ""
        )}
      </>
    );
  };

  useEffect(() => {
    const loadData = async () => {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/documentation_generales?page=${currentPage}&sort_by=${sortField}_${order}&key=${debounceSearch}&categories_document=${categorie}&types_document=${type}&annee=${annee}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (response.status === 403) navigate(`${backUrl}/forbidden`);
        if (response.status === 500) navigate(`${backUrl}/error`);
        if (response.status === 203) navigate(`${backUrl}/error404`);
        if (response.status === 401) {
          localStorage.removeItem("auth_token_" + api);
          localStorage.removeItem("authUser_" + api);
          localStorage.removeItem("sideBar_" + api);
          navigate(`${backUrl}/login`);
          window.location.reload(false);
        }
        const newData = await response.json();
        setDocData(newData);
      } catch (error) {
        console.error("Erreur lors de la récupération des données : ", error);
      }
    };
    loadData();
  }, [debounceSearch, categorie, type, annee]);

  const lastId = localStorage.getItem("lastId");
  const previousPath = localStorage.getItem("previousPath_" + api);

  return (
    <React.Fragment>
      <div className="page-content">
        {previousPath ==
        `${backUrl}/documentation_generales/${lastId}/edit` ? (
          <LastModificationAlert path={"documentation_generales"} />
        ) : null}
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5 className="mb-0 card-title text-primary flex-grow-1">
                      Documentation générale (
                      {loading ? "--" : docData?.total_records})
                    </h5>
                  </div>
                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      <Link
                        to={`${backUrl}/documentation_generales/new`}
                        className="btn btn-sm btn-primary"
                      >
                        <i className="bx bx-plus"></i>Ajouter
                      </Link>
                    </div>
                  </div>
                </CardBody>
                <CardBody>
                  {!loading ? (
                    <>
                      <Row className="mb-3">{renderFilters()}</Row>
                    </>
                  ) : (
                    ""
                  )}

                  <div className="table-responsive">
                    {!loading ? (
                      <>
                        <table className="table">
                          <thead>
                            <tr>
                              {docData?.can_edit === false &&
                              docData?.can_show === false &&
                              docData?.can_destroy === false ? (
                                <th></th>
                              ) : (
                                <th
                                  style={{ cursor: "default" }}
                                  key="Action"
                                  className="text"
                                >
                                  Action
                                </th>
                              )}
                              {docData?.headers
                                ?.filter((h) => h.visible !== false)
                                ?.map(({ header, accessorKey, sortable }) => {
                                  const cl = sortable ? (
                                    sortField === accessorKey ? (
                                      order === "asc" ? (
                                        <i className="bx bx-up-arrow-alt"></i>
                                      ) : (
                                        <i className="bx bx-down-arrow-alt"></i>
                                      )
                                    ) : (
                                      ""
                                    )
                                  ) : (
                                    ""
                                  );
                                  return (
                                    <th
                                      key={accessorKey}
                                      onClick={
                                        sortable
                                          ? () =>
                                              handleSortingChange(accessorKey)
                                          : null
                                      }
                                      className="text-nowrap"
                                      style={{
                                        cursor: sortable ? "pointer" : "default",
                                      }}
                                    >
                                      {header}
                                      {cl}
                                    </th>
                                  );
                                })}
                            </tr>
                          </thead>
                          <tbody>
                            {docData?.data?.map((rowData, rowIndex) => (
                              <tr key={rowIndex}>
                                <td>
                                  <ul className="list-unstyled hstack gap-1 mb-0">
                                    {docData?.can_show ? (
                                      <li
                                        data-bs-toggle="tooltip"
                                        data-bs-placement="top"
                                        title="Voir"
                                      >
                                        <Link
                                          className="btn btn-sm btn-soft-primary"
                                          to={`${backUrl}/documentation_generales/${rowData.id}`}
                                        >
                                          <i className="mdi mdi-eye-outline"></i>
                                        </Link>
                                      </li>
                                    ) : null}
                                    {docData?.can_edit ? (
                                      <li title="Editer">
                                        <Link
                                          className="btn btn-sm btn-soft-info"
                                          to={`${backUrl}/documentation_generales/${rowData.id}/edit`}
                                          state={{ active: "details" }}
                                        >
                                          <i className="mdi mdi-pencil-outline"></i>
                                        </Link>
                                      </li>
                                    ) : null}
                                    {docData?.can_destroy ? (
                                      <li title="Supprimer">
                                        <DeleteButton
                                          url={`https://www.fluxod.com/${api}/documentation_generales/${rowData.id}`}
                                        />
                                      </li>
                                    ) : null}
                                  </ul>
                                </td>
                                {docData?.headers
                                  ?.filter((h) => h.visible !== false)
                                  ?.map(({ header, accessorKey, type: colType }) => (
                                    <React.Fragment
                                      key={`${rowIndex}-${accessorKey}`}
                                    >
                                      {colType === "link" &&
                                      rowData[accessorKey] != null ? (
                                        <td
                                          style={{
                                            padding: "12px",
                                            fontFamily: "Sans-Serif",
                                          }}
                                        >
                                          <a
                                            href={rowData[accessorKey]}
                                            target="_blank"
                                            rel="noreferrer"
                                          >
                                            <i
                                              style={{
                                                fontSize: "25px",
                                                paddingLeft: "8px",
                                                textAlign: "center",
                                                verticalAlign: "middle",
                                              }}
                                              className="bx bx-download"
                                            ></i>
                                          </a>
                                        </td>
                                      ) : (
                                        <td
                                          style={{
                                            padding: "12px",
                                            fontFamily: "Sans-Serif",
                                          }}
                                        >
                                          {rowData[accessorKey] || "——"}
                                        </td>
                                      )}
                                    </React.Fragment>
                                  ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </>
                    ) : (
                      <Spinners setLoading={setLoading} setWait={400} />
                    )}
                  </div>
                </CardBody>
                <div className="d-flex justify-content-center mt-3">
                  {!loading ? (
                    <ReactPaginate
                      previousLabel={"<<"}
                      breakLabel={"..."}
                      nextLabel={">>"}
                      pageCount={docData.pages}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={3}
                      onPageChange={handlePageChange}
                      containerClassName={"pagination justify-content-center"}
                      pageClassName={"page-item"}
                      pageLinkClassName={"page-link"}
                      previousClassName={"page-item"}
                      previousLinkClassName={"page-link"}
                      nextClassName={"page-item"}
                      nextLinkClassName={"page-link"}
                      breakClassName={"page-item"}
                      breakLinkClassName={"page-link"}
                      activeClassName={"active"}
                      forcePage={currentPage - 1}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
      <ToastContainer />
    </React.Fragment>
  );
}

export default DocumentationGenerales;
